var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { default as React, useState } from 'react';
import { renderItemToMenuKey, renderItemToString } from '../Shared/MedicationSharedMethods';
import { white50 } from '../Styles/Colours';
import { Button, ButtonVariant } from '../Components/Button';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { CloseIcon } from '../Components/Icons';
import styles from './ReprescribeFreeTextMedicationDialog.module.css';
import { MedicationType, prettyPrintMedicationType } from '../Contracts/MedicationModels';
import { isSingleSelectSingleValue, StyledSelect } from '../Components/StyledSelect';
import { usePermissions } from '../Hooks/usePermissions';
import { MedicationsPermissions } from '../MedicationsPermissions';
export var ReprescribeFreeTextMedicationDialog = function (props) {
    var validMedicationTypes = [];
    var permissions = usePermissions({
        prescribeMedicationsTakeHomeScript: MedicationsPermissions.PrescribeMedicationsTakeHomeScript,
        prescribeMedicationsMedicationOrder: MedicationsPermissions.PrescribeMedicationsMedicationOrder,
        prescribeMedicationsEnrmcScript: MedicationsPermissions.PrescribeMedicationsEnrmcScript,
        prescribeComplementaryTherapyOrder: MedicationsPermissions.PrescribeComplementaryTherapyOrder
    });
    if (permissions.prescribeMedicationsTakeHomeScript) {
        validMedicationTypes.push({ value: MedicationType.TakeHomeScript });
    }
    if (permissions.prescribeMedicationsMedicationOrder) {
        validMedicationTypes.push({ value: MedicationType.MedicationOrder });
    }
    if (permissions.prescribeMedicationsEnrmcScript) {
        validMedicationTypes.push({ value: MedicationType.EnrmcScript });
    }
    if (permissions.prescribeComplementaryTherapyOrder) {
        validMedicationTypes.push({ value: MedicationType.ComplementaryTherapyOrder });
    }
    var _a = __read(useState(null), 2), medicationType = _a[0], setMedicationType = _a[1];
    return (React.createElement(StyledDialog, { open: true, size: 'xxxs', modal: true, testId: 'represcribe-free-text-medication', title: 'Free-text medication history item', tighterActionButtons: true, titleBarRight: React.createElement(Button, { iconOnly: true, onClick: function () { return props.onClose(); }, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'represcribe-medication-close', tooltip: 'Close' },
            React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true })), actions: [
            React.createElement(StyledDialogButton, { variant: ButtonVariant.light, key: 'cancel', testId: 'represcribe-medication-cancel', onClick: function () { return props.onClose(); } }, "Cancel"),
            React.createElement(StyledDialogButton, { variant: ButtonVariant.primary, key: 'launch', testId: 'represcribe-medication-launch', disabled: !medicationType, onClick: function () {
                    if (medicationType) {
                        props.onSubmit(medicationType);
                    }
                } }, "Launch medication browser")
        ], contentComponent: React.createElement("div", { className: styles.dialogContent },
            React.createElement("div", { className: styles.instructions },
                "This medication history item was recorded with a ",
                React.createElement("em", null, "free-text medication name"),
                ". To represcribe this medication, select a medication type and choose an equivalent medication in the medication browser."),
            React.createElement(StyledSelect, { isClearable: true, label: 'Medication type', maxResults: 4, itemToString: renderItemToString, itemToMenuKey: renderItemToMenuKey, customItemRender: function (suggestion) { return React.createElement("span", null, prettyPrintMedicationType(suggestion === null || suggestion === void 0 ? void 0 : suggestion.value)); }, onSelection: function (it) {
                    if (it === null) {
                        setMedicationType(null);
                    }
                    else if (isSingleSelectSingleValue(it)) {
                        setMedicationType(it.value);
                    }
                }, suggestions: validMedicationTypes, testId: 'selection-input-medication-type' })) }));
};
